const jsonSchemaStore  = ({
    default_title,
    locale,
}) => {
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    const arrayLang = locale.split('_');

    script.innerHTML = JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": ["Organization", "Corporation"],
                "name": default_title,
                "url": process.env.HOST_URL,
                "logo": `${process.env.HOST_URL}/media/logo/stores/1/logo.png`,
                "sameAs": [
                    "https://www.facebook.com/buywholefoodsonline",
                    "https://www.instagram.com/buywholefoodsonline",
                    "https://www.tiktok.com/@buywholefoodsonline"
                ],
                "contactPoint": [
                    {
                        "@type": "ContactPoint",
                        "contactType": "customer service",
                        "email": "support@buywholefoodsonline.co.uk",
                        "areaServed": arrayLang[0],
                        "availableLanguage": arrayLang[1]
                    }
                ],
                "hasMerchantReturnPolicy": {
                    "@type": "MerchantReturnPolicy",
                    "applicableCountry": arrayLang[0],
                    "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                    "merchantReturnDays": 30,
                    "returnMethod": "https://schema.org/ReturnByMail",
                    "returnFees": "https://schema.org/ReturnFeesCustomerResponsibility"
                }
            },
            {
                "@type": "WebSite",
                "url": process.env.HOST_URL,
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                        "@type": "EntryPoint",
                        "urlTemplate": `${process.env.HOST_URL}/search?search={search_term_string}`,
                    },
                    "query-input": "required name=search_term_string"
                }
            }
        ]
    });

    document.head.appendChild(script);
};

export  {
    jsonSchemaStore,
}
